
import { defineComponent, ref, onMounted, computed } from "vue";
import HeaderTitleWithSearch from "@/components/HeaderTitleWithSearch.vue";
import { api } from "@/services/Api";
import swal from "sweetalert2";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";
import { Coupon } from "@/models/Product";
import ProductCard from "@/components/ProductCard.vue";
import q from "q";
import BackAndCancelFooter from "@/components/BackAndCancelFooter.vue";
import moment from "moment";
import { ProductListItem } from "@/models/Product";

export default defineComponent({
  name: "ClubProductList",
  props: {
    clubId: {
      type: Number,
      required: true,
    },
  },
  components: { HeaderTitleWithSearch, ProductCard, BackAndCancelFooter },
  async setup(props) {
    const showAll = ref(false);
    const { t } = useI18n();
    const searchText = ref("");
    const store = useStore();
    const products = ref<ProductListItem[]>([]);
    const productsView = computed(() => {
      if (showAll.value) {
        return products.value;
      } else {
        return products.value.filter((x) => x.withCoupon);
      }
    });
    
    const orderPriceType = computed(() =>
        store.state.order.priceType
    );
    const orderProducts = computed(() =>
      store.state.order.products.map((x) => x.id)
    );
    const coupons = computed(
      () => store.getters.getCouponsByOrderBusinessClient as Coupon[]
    );
    function onSelectProduct(item: any) {
      console.log(item);
    }
    function changeSearchText(newValue: string) {
      searchText.value = newValue;
    }
    function couponExist(productId: number) {
      const today = moment().startOf("day");
      const findIndex = coupons.value.findIndex(
        (x) =>
          x.productIds.includes(productId) &&
          moment(x.validDateFrom).isSameOrBefore(today) &&
          moment(x.validDateTo).isSameOrAfter(today) && 
          x.priceTypeIds.includes(orderPriceType.value)
      );
      return findIndex >= 0;
    }
    async function onMountedAction() {
      swal.showLoading();
      const storeProducts = store.getters
        .productsByPriceType as ProductListItem[];
      products.value = JSON.parse(JSON.stringify(storeProducts));
      var delay = q.delay(400);
      products.value.forEach((product) => {
        product.withCoupon = couponExist(product.id);
      });
      await delay;
      swal.close();
    }
    onMounted(onMountedAction);
    return {
      onSelectProduct,
      changeSearchText,
      products,
      orderProducts,
      showAll,
      couponExist,
      productsView,
      coupons,
      orderPriceType
    };
  },
});
